// extracted by mini-css-extract-plugin
export default {"inner":"wFDks","emptyState":"pPtZ9"};